import { Button, Row, Space, Table } from "antd";
import { ExcelSVG } from "assets";
import React, { useMemo, useState } from "react";
import { backToTheDoctorColumns } from "../config";
import { useAppDispatch } from "redux/hooks";
import { setIdPhieuKham } from "redux/reducer/common";
import { setIdCustomerCare } from "redux/reducer/customerCare";

const BackToTheDotorPatient = ({
  data,
  setParams,
  params,
  total,
  loading,
  childTab,
  onExportEcel,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>();

  const onChangePagination = (page, pageSize) => {
    setParams({ ...params, page: page, limit: pageSize });
  };
  const dispatch = useAppDispatch();

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      dispatch(setIdCustomerCare(selectedRows[0].id));
      setSelectedRowKeys(selectedRowKeys);
      dispatch(setIdPhieuKham(selectedRows[0].idPhieuKham));
    },
  };
  useMemo(() => {
    setSelectedRowKeys([]);
    setParams({
      ...params,
      page: 1,
    });
  }, [childTab]);
  return (
    <div className="container">
      <Space direction="vertical" style={{ width: "100%" }}>
        <Row justify={"start"}>
          <Button icon={<ExcelSVG />} className="custom-btn" onClick={onExportEcel}>
            Xuất báo cáo
          </Button>
        </Row>
        <Table
          columns={backToTheDoctorColumns}
          dataSource={data}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            showSizeChanger: true,
            total: total,
            current: params.page,
            onChange: onChangePagination,
          }}
          rowSelection={{
            type: "radio",
            ...rowSelection,
          }}
          scroll={{ x: 600 }}
          bordered
        />
      </Space>
    </div>
  );
};

export default BackToTheDotorPatient;
